<template>
  <div class="product-link">
    <div>
      <span>投保链接支持参数动态替换，例如：https://lifeisgreat.com/insure?uid=${jobNumber}。</span>
      <span v-if="!look" class="table-btn" @click="look=true">点击查看</span>
      <span v-else class="table-btn" @click="look=false">收起</span>
      <span>全部动态参数说明</span>
    </div>
    <div class="table-box" v-if="look">
      <div class="table">
        <div class="tr title-tr">可以使用的动态参数</div>
        <div class="tr th">
          <div class="td">变量名</div>
          <div class="td">变量含义</div>
        </div>
        <div class="tr" v-for="item in keys" :key="item.key">
          <div class="td">{{item.key}}</div>
          <div class="td">{{item.name}}</div>
        </div>
      </div>
      <div class="table" v-if="hasKeys.length">
        <div class="tr title-tr">已经使用的动态参数</div>
        <div class="tr th">
          <div class="td">变量名</div>
          <div class="td">变量含义</div>
        </div>
        <div class="tr" v-for="item in hasKeys" :key="item.key">
          <div class="td">{{item.key}}</div>
          <div class="td">{{item.name}}</div>
        </div>
      </div>
      <!-- <div class="arrow-up" @click="look=false">
        <span class="table-btn"><Icon type="ios-arrow-up" /> 收起</span>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["link"],
  components: {},
  data() {
    return {
      look:false,
      keys: [
        {key:'name',name:'业务员姓名'},
        {key:'jobNumber',name:'工号'},
        {key:'mobile',name:'手机号码'},
        {key:'insurerJobNumber',name:'保险公司工号'},
        {key:'channelCode',name:'签约渠道号'},
        {key:'practiceNumber',name:'执业证编号'},
        {key:'gender',name:'代理人性别'},
        {key:'birthday',name:'代理人生日'},
        {key:'idCard',name:'证件类型'},
        {key:'idCardNumber',name:'证件号码'},
      ],
      hasKeys: [],
    };
  },
  watch: {
    link:{
      handler(){
        if(!this.link) {
          return;
        }
        this.hasKeys = [];
        this.keys.forEach(item=>{
          if(this.link.includes("${"+item.key+"}")){
            this.hasKeys.push(item);
            this.look = true;
          }
        })
      },
      immediate: true
    }
  },
  computed: {},
  methods: {
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "./productLink.scss";
</style>
